export default "__VITE_ASSET__871f444c__"